<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">Gruppo Fasi</v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Bottone di aggiunta -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="openAddDialog"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary">mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Aggiungi Fasi</span>
      </v-tooltip>

      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="salvaGruppoFasi" small v-bind="attrs" v-on="on">
            <v-icon color="success">mdi-floppy</v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-5" style="overflow-y: auto">
      <v-data-table
        dense
        :headers="header_gruppo_fasi"
        calculate-widths
        :items="items_gruppo_fasi.filter((f) => f.validita == 1)"
      >
        <!-- Bottone di deselezione -->
        <template v-slot:[`item.deseleziona`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                style="float: left"
                @click="eliminaAssociazione(item)"
                small
              >
                <v-icon color="error">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Aggiungi</span>
          </v-tooltip>
        </template>

        <!-- Spazio della des_commessa -->
        <template v-slot:[`item.des_commessa`]="{ item }">
          {{
            item.des_commessa == null || item.des_commessa == ""
              ? "N/D"
              : item.des_commessa
          }}
        </template>
      </v-data-table>
    </v-card-text>

    <!-- Dialog aggiunta -->
    <v-dialog persistent v-model="aggiungi_fasi_dialog" width="60vw">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Fasi Associabili
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di aggiunta fasi selezionate -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="addFasiSelezionate" small v-bind="attrs" v-on="on">
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="closeAddDialog" small v-bind="attrs" v-on="on">
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-container fluid>
            <v-row align="center" dense justify="center">
              <v-col cols="3">
                <v-text-field
                  dense
                  hide-details
                  @keydown.enter="getFasiAggiuntaGruppo"
                  label="Cod. Articolo"
                  outlined
                  style="border-radius: 0px"
                  v-model="filtro_cod_articolo"
                >
                </v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  dense
                  hide-details
                  @keydown.enter="getFasiAggiuntaGruppo"
                  label="Cod. Commessa"
                  outlined
                  style="border-radius: 0px"
                  v-model="filtro_cod_commessa"
                >
                </v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  dense
                  hide-details
                  @keydown.enter="getFasiAggiuntaGruppo"
                  label="Riferimento / Cod. Ordine"
                  outlined
                  style="border-radius: 0px"
                  v-model="filtro_riferimento"
                >
                </v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  dense
                  hide-details
                  @keydown.enter="getFasiAggiuntaGruppo"
                  label="Cod. Fase"
                  outlined
                  style="border-radius: 0px"
                  v-model="filtro_cod_fase"
                >
                </v-text-field>
              </v-col>
              <v-col align="left" cols="1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="getFasiAggiuntaGruppo"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary">mdi-magnify</v-icon>
                    </v-btn>
                  </template>
                  <span>Cerca</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-data-table
                  dense
                  :headers="header_gruppo_fasi_aggiungibili"
                  :items="items_gruppo_fasi_aggiungibili"
                >
                  <!-- Bottone della selezione -->
                  <template v-slot:[`item.seleziona`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          style="float: left"
                          @click="selezionaFase(item)"
                          small
                        >
                          <v-icon
                            :color="
                              item.id_commessa_dettaglio_abbinante == null &&
                              item.is_abbinante == 0 &&
                              item.abbinato_qui == false
                                ? item.selezionato == false
                                  ? 'success'
                                  : 'error'
                                : 'orange'
                            "
                          >
                            {{
                              item.id_commessa_dettaglio_abbinante == null &&
                              item.is_abbinante == 0 &&
                              item.abbinato_qui == false
                                ? item.selezionato == false
                                  ? "mdi-check"
                                  : "mdi-close"
                                : "mdi-information"
                            }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Aggiungi</span>
                    </v-tooltip>
                  </template>

                  <!-- Spazio della des_commessa -->
                  <template v-slot:[`item.des_commessa`]="{ item }">
                    {{
                      item.des_commessa == null || item.des_commessa == ""
                        ? "N/D"
                        : item.des_commessa
                    }}
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <!-- Overlay di caricamento -->
      <v-overlay :value="overlay_aggiunta" style="z-index: 1">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <!-- Snackbar -->
      <SnackbarQV ref="SnackbarQVAggiunta" />
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" style="z-index: 1">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "",
  components: { SnackbarQV },
  props: {
    cod_commessa_padre_gruppo: {
      type: String,
      default: null,
    },
    cod_fase_padre_gruppo: {
      type: Number,
      default: null,
    },
    id_padre_gruppo_fasi: {
      type: Number,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Variabili d'appoggio

      // Modal
      aggiungi_fasi_dialog: false,
      filtro_cod_articolo: "",
      filtro_cod_commessa: "",
      filtro_cod_fase: "",
      filtro_riferimento: "",
      overlay: false,
      overlay_aggiunta: false,

      // Array
      header_gruppo_fasi: [
        {
          text: "Cod. Commessa",
          value: "cod_commessa",
          sortable: false,
        },
        {
          text: "Cod. Articolo",
          value: "cod_articolo",
          sortable: false,
        },
        {
          text: "Des. Commessa",
          value: "des_commessa",
          sortable: false,
        },
        {
          text: "Riferimento",
          value: "riferimento",
          sortable: false,
        },
        {
          text: "Cod. Fase",
          value: "cod_fase",
          sortable: false,
        },
        {
          text: "Deseleziona",
          value: "deseleziona",
          sortable: false,
          width: "100px",
        },
      ],
      header_gruppo_fasi_aggiungibili: [
        {
          text: "Seleziona",
          value: "seleziona",
          sortable: false,
          width: "100px",
        },
        {
          text: "Cod. Articolo",
          value: "cod_articolo",
          sortable: false,
        },
        {
          text: "Cod. Commessa",
          value: "cod_commessa",
          sortable: false,
        },
        {
          text: "Riferimento",
          value: "riferimento",
          sortable: false,
        },
        {
          text: "Des. Commessa",
          value: "des_commessa",
          sortable: false,
        },
        {
          text: "Cod. Fase",
          value: "cod_fase",
          sortable: false,
        },
        {
          text: "Des. Fase",
          value: "des_fase",
          sortable: false,
        },
      ],
      items_gruppo_fasi: new Array(),
      items_gruppo_fasi_aggiungibili: new Array(),
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.id_padre_gruppo_fasi != null) {
          this.getGruppoFasi();
        }
      },
    },
  },
  methods: {
    addFasiSelezionate() {
      this.items_gruppo_fasi_aggiungibili
        .filter((f) => f.selezionato == true)
        .forEach((f) => {
          this.items_gruppo_fasi.push({
            id_commessa_dettaglio_gruppo: -1,
            id_commessa_dettaglio_abbinante: this.id_padre_gruppo_fasi,
            id_commessa_dettaglio_abbinato: f.id_commessa_dettaglio,
            cod_commessa: f.cod_commessa,
            des_commessa: f.des_commessa,
            cod_articolo: f.cod_articolo,
            cod_fase: f.cod_fase,
            riferimento: f.riferimento,
            validita: 1,
          });
        });

      this.filtro_cod_articolo = null;
      this.filtro_cod_commessa = null;
      this.filtro_riferimento = null;
      this.filtro_cod_fase = null;
      this.items_gruppo_fasi_aggiungibili = new Array();
      this.aggiungi_fasi_dialog = false;
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    closeAddDialog() {
      this.items_gruppo_fasi_aggiungibili = new Array();
      this.filtro_riferimento = null;
      this.filtro_cod_fase = null;
      this.filtro_cod_articolo = null;
      this.filtro_cod_commessa = null;
      this.aggiungi_fasi_dialog = false;
    },
    eliminaAssociazione(arg) {
      this.$set(arg, "validita", 0);
    },
    getFasiAggiuntaGruppo() {
      if (
        (this.filtro_cod_articolo == null || this.filtro_cod_articolo == "") &&
        (this.filtro_cod_commessa == null || this.filtro_cod_commessa == "") &&
        (this.filtro_riferimento == null || this.filtro_riferimento == "") &&
        (this.filtro_cod_fase == null || this.filtro_cod_fase == "") 
      ) {
        this.$refs.SnackbarQV.print("orange", "Valorizzare almeno un filtro.");
        return;
      }

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getfasiaggiuntagruppo",
          token: localStorage.user_token,
          cod_articolo: this.filtro_cod_articolo,
          cod_commessa: this.filtro_cod_commessa,
          riferimento: this.filtro_riferimento,
          cod_fase: this.filtro_cod_fase,
        },
      };

      this.overlay_aggiunta = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay_aggiunta = false;
          if (res.status === 200) {
            this.items_gruppo_fasi_aggiungibili = new Array();

            // Aggiungo solo le fasi che non sono state ancora aggiunte.
            res.data.result.forEach((f) => {
              f.abbinato_qui = false;
              f.selezionato = false;

            /* Ho bisogno del flag abbinato_qui perché se non ce l'ho 
             * non posso stampare efficacemente fase e codice della 
             * commessa attuale se ho aggiunto adesso la fase in questione 
             * mella tabella principale e non l'ho ancora salvata. */
              this.items_gruppo_fasi.forEach((f2) => {
                if (
                  f2.id_commessa_dettaglio_abbinato ==
                    f.id_commessa_dettaglio &&
                  f2.validita == 1
                ) {
                  f.abbinato_qui = true;
                }
              });
            });

            this.items_gruppo_fasi_aggiungibili = res.data.result;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay_aggiunta = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    getGruppoFasi() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getgruppofasi",
          token: localStorage.user_token,
          id_commessa_dettaglio: this.id_padre_gruppo_fasi,
          modalita: "search_abbinato",
        },
      };

      this.overlay = true;
      this.items_gruppo_fasi = new Array();

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.items_gruppo_fasi = res.data.result.gruppo;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    openAddDialog() {
      this.aggiungi_fasi_dialog = true;
    },
    salvaGruppoFasi() {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessadettagliogruppo",
          token: localStorage.user_token,
          tabella: this.items_gruppo_fasi.filter(
            (f) => f.validita == 1 || f.id_commessa_dettaglio_gruppo > -1
          ),
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.$emit("salvataggio_eseguito");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    selezionaFase(arg) {
      if (
        arg.is_abbinante == 0 &&
        arg.abbinato_qui == false &&
        arg.id_commessa_dettaglio_abbinante == null
      ) {
        this.$set(arg, "selezionato", !arg.selezionato);
      } else if (arg.abbinato_qui == true) {
        this.$refs.SnackbarQVAggiunta.print(
          "orange",
          `Questa fase è abbinata alla fase ${this.cod_fase_padre_gruppo} della commessa ${this.cod_commessa_padre_gruppo}.`
        );
      } else if (arg.id_commessa_dettaglio_abbinante != null) {
        this.$refs.SnackbarQVAggiunta.print(
          "orange",
          `Questa fase è abbinata alla fase ${arg.cod_fase_abbinante} della commessa ${arg.cod_commessa_abbinante}.`
        );
      } else if (arg.is_abbinante == 1) {
        this.$refs.SnackbarQVAggiunta.print(
          "orange",
          "Questa fase è già abbinante rispetto ad altre."
        );
      }
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>